@if (section().items.length) {
  @if (section().searchable && !iconOnly()) {
    <input
      type="text"
      class="section-search"
      [placeholder]="section().searchPlaceholder || 'Search...'"
      [ngModel]="searchValue()"
      (ngModelChange)="searchValue.set($event)"
    />
  }
  @for (item of filteredItems(); track item.id ?? item.url ?? $index) {
    <app-menu-item
      [item]="item"
      [iconOnly]="iconOnly()"
      [selected]="item.id != null && item.id === selectedId()"
      (select)="itemSelect.emit($event)"
    />
  }
}
